import { createSlice } from "@reduxjs/toolkit";
import { favoritesAsync } from "./actions";

// state数据
let initialState = {
  pending: false,
  favorites: 0,
};

export const detailSlice = createSlice({
  name: "detail",
  initialState,
  reducers: {
    setFavoritesPending: (state, action) => {
      state.pending = action.payload;
    },
    setFavorites: (state, action) => {
      const count = action.payload;
      if (count > 0) {
        state.favorites = action.payload;
      } else {
        state.favorites = 0;
      }
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(favoritesAsync.pending, (state) => {
        state.pending = true;
      })
      .addCase(favoritesAsync.fulfilled, (state, { payload }) => {
        state.favorites = payload;
        state.pending = false;
      })
      .addCase(favoritesAsync.rejected, (state, action) => {
        if (action?.payload) {
          state.favorites = payload;
        }
        state.pending = false;
      });
  },
});

export const { setFavorites, setFavoritesPending } = detailSlice.actions;

export default detailSlice.reducer;
